<template>
  <ApolloMutation
    :mutation="mutation"
    :update="update"
    :variables="{ id: myRun.id, config: JSON.stringify(myRun.config) }"
    @done="onDone"
    @error="onError"
    tag
  >
    <template slot-scope="{ mutate, loading }">
      <v-btn
        :loading="loading"
        @click="saveRun(mutate)"
        color="primary"
      >
        Save
        <v-progress-circular
          :size="24"
          :width="3"
          indeterminate
          slot="loader"
        ></v-progress-circular>
      </v-btn>
    </template>
  </ApolloMutation>
</template>

<script>
import { MY_RUNS, UPDATE_RUN } from '@/graphql.gql';
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  data() {
    return {
      mutation: UPDATE_RUN,
    };
  },
  methods: {
    update(
      store,
      {
        data: { updateRun },
      }
    ) {
      try {
        const data = store.readQuery({ query: MY_RUNS });
        const index = data.myRuns.findIndex((obj) => obj.id === updateRun.id);
        data.myRuns[index] = updateRun;
        store.writeQuery({ query: MY_RUNS, data });
      } catch (error) {
        // do nothing
      }
    },
    onDone() {
      this.$emit('run-saved');
    },
    onError(error) {
      // eslint-disable-next-line no-console
      console.log(error);
      this.$snackbar.show('We could not update this run. Please, try again.');
    },
    async saveRun(mutate) {
      if (this.$v.myRun.config.$invalid) {
        this.$snackbar.show('Please, fill in all the fields of the form correctly.');
        return;
      }
      await mutate();
    },
  },
};
</script>
